import React from 'react';


export default function withRouter(Component) {
    Component.contextTypes = {
        router: React.PropTypes.func.isRequired
    };

    return Component;
}


/** WEBPACK FOOTER **
 ** ./app/src/utils/with-router.js
 **/